<template>
    <div id="rank-group">
        <div class="rank-name">{{rankName}}</div>
        <button class="btn-rank" @click="btnA=!btnA;emitData()" v-bind:class="{ selected: btnA }">A</button>
        <button class="btn-rank" @click="btnB=!btnB;emitData()" v-bind:class="{ selected: btnB }">B</button>
        <button class="btn-rank" @click="btnC=!btnC;emitData()" v-bind:class="{ selected: btnC }">C</button>
        <button class="btn-rank" @click="btnD=!btnD;emitData()" v-bind:class="{ selected: btnD }">D</button>
    </div>
</template>

<script>
export default {
    name: 'rank-group',
    props: ['value','rankName'],
    //  props: {
    //     rankName:{
    //         type: String,
    //         default: ""
    //     }
    // },
    data(){
        return {
            btnA: false,
            btnB: false,
            btnC: false,
            btnD: false
        }
    },
    created(){
        if(this.value == null)
            this.$emit('input',{'A':this.btnA,'B':this.btnB,'C':this.btnC,'D':this.btnD});
        else
        {
            this.btnA = this.value.A? this.value.A:false;
            this.btnB = this.value.B? this.value.B:false;
            this.btnC = this.value.C? this.value.C:false;
            this.btnD = this.value.D? this.value.D:false;
            this.$emit('input',{'A':this.btnA,'B':this.btnB,'C':this.btnC,'D':this.btnD});
        }
    },
    methods:{
        emitData() {
            this.$emit('input',{'A':this.btnA,'B':this.btnB,'C':this.btnC,'D':this.btnD});
        }
    }
}

</script>

<style lang="scss" scoped>

#rank-group{
    margin-top: 10px;
    margin-bottom: 10px;
    
    .rank-name {
        width:100px;
        margin-right:10px;
        display: inline-block;
    }

    .btn-rank {
        display: inline-block;
        text-align: center;
        text-decoration: none;

        width:50px;
        height:25px;
        margin-right:5px;

        border: 0 none #A8A8A8;
        border-bottom: 2px solid #A8A8A8;


        background-color: white; /* Green */
        color:#A8A8A8;
        font-size: 16px;
        font-weight: bold;
    }

    .btn-rank {
    background-position: center;
    transition: background 0.8s;
    }

    .btn-rank:hover {
        cursor: pointer;
        color: #3F51B5;
    }

    .btn-rank:active {
        background-size: 100%;
        transition: background 0s;
    }

    .selected {
        cursor: pointer;
        border: 0 none #ccc;
        border-bottom: 2px solid blue;
        color: #3F51B5;
    }

}









</style>
